module.exports = {"id":"170305","name":"Cole Skuse","rating":"72","photo":"./data/images/photos/4/170305.png","club":{"name":"Ipswich Town","logo":"./data/images/clubs/IpswichTown.png"},"positions":["MDC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ColeSkuse0.json
// module id = 846
// module chunks = 0